import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import ProductCard from '~/components/molecules/Global/ProductCard.vue';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

export default {
  name: 'CustomProductAddToCartModal',
  components: {
    MdmModal: MdmModal,
    ProductCard: ProductCard
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      quantity: 1,
      show: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    cartUrl: function cartUrl() {
      return this.buildCartUrl(this.locale);
    }
  })
};